module.exports = __webpack_public_path__ + "static/travelnevada-logo-df1cfdd63331a4332eab464629781939.png";